export default function(t,e){return t===e.length-1};
//# sourceMappingURL=index.m.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@brazilian-utils/helper-is-last-char/dist/index.m.js
// module id = 218
// module chunks = 0